module.exports = __webpack_public_path__ + "img/20190625162038952.57509bfb.png";